import React from "react";
import KeyDropdown from "./key-dropdown-component";
import QualityDropdown from "./quality-dropdown-component";
import BassDropdown from "./bass-dropdown-component";
import ChordDiagram from "./chord-diagram-component";
import Footer from "./footer-component"

const ChordFinder = () => {
  return (
    <div className="background-image">
      <div className="glass-panel">
        <h1 className="title">FRETBOARD</h1>
        <p className="subtitle">Select a key, quality and bass note</p>

        <div className="dropdown-group">
          <KeyDropdown />
          <QualityDropdown />
          <BassDropdown />
        </div>

        <div className="chord-area">
          <ChordDiagram />
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ChordFinder;
